import { ReactNode } from 'react';
import { View } from 'react-native';
import { cn } from '../../lib/utils';

export const StatsBox = ({
  className,
  children,
}: {
  className?: string;
  children?: ReactNode;
}) => {
  return (
    <View
      className={cn(
        'p-3 rounded-2xl border border-neutral-500 overflow-hidden',
        className,
      )}>
      {children}
    </View>
  );
};
